function generatePresetTag(mi) {
    const pattern = "PDS3";
    const resCount = 4;
    const defaultLang = "Korean";
    const exportScript = "pds";
    const hasNcp = false; // ogirinally, true
    const relationLink = true;
    const dummy = true;
    const manualAction = true;
    const result = `<preset>\n` +
        `<pattern>${pattern}</pattern>\n` +
        `<sound set="true" filter="*.mp3"/>\n` +
        `<video set="true" filter="*.wmv,*.avi"/>\n` +
        `<image set="true" filter="*.jpg,*.png"/>\n` +
        `<res_count>${resCount}</res_count>\n` +
        `<default_res_lang>${defaultLang}</default_res_lang>\n` +
        `<export_script>${exportScript}</export_script>\n` +
        `<ncp>${hasNcp}</ncp>\n` +
        `<relation_link>${relationLink}</relation_link>\n` +
        `<dummy>${dummy}</dummy>\n` +
        `<manual_action>${manualAction}</manual_action>\n` +
        `<symbol_setting align="4" bgcolor="#00ff00" bgalpha="70" outline_alpha="70" textcolor="#000000" textsize="9" texton="1"/>\n` +
        `<margin left="0" top="0" right="0" bottom="0"/>\n` +
        `</preset>`;
    return result;
}
function generateBookTag(mi) {
    const revision = 15;
    const lineSegmentLength = 1;
    const dotSize = 1;
    const dpi = 600;
    const kind = 0;
    const title = mi.docMap.filename;
    const author = "NeoLAB POD Generator";
    const { section, owner, book, page: numStartPage } = mi.docMap.printPageInfo;
    const isLineCode = false;
    const numPages = mi.docMap.numPages;
    const result = `<book>\n` +
        `<title>${title}</title>\n` +
        `<author>${author}</author>\n` +
        `<section>${section}</section>\n` +
        `<owner>${owner}</owner>\n` +
        `<code>${book}</code>\n` +
        `<revision>${revision}</revision>\n` +
        `<scale>0.001</scale>\n` +
        // `<start_page side="">${numStartPage}</start_page>\n` +
        `<start_page side="">1</start_page>\n` +
        `<dot_is_line_segment>${isLineCode}</dot_is_line_segment>\n` +
        `<line_segment_length>${lineSegmentLength}</line_segment_length>\n` +
        `<target_dpi>${dpi}</target_dpi>\n` +
        `<dotsize>${dotSize}</dotsize>\n` +
        `<segment_info sub_code="" total_size="${numPages}" size="${numPages}" current_sequence="0" ncode_start_page="${numStartPage}" ncode_end_page="${numStartPage + numPages - 1}"/>\n` +
        `<extra_info>\n` +
        `pdf_page_count=${numPages}\n` +
        `</extra_info>\n` +
        `<kind>${kind}</kind>\n` +
        `</book>`;
    return result;
}
function generateTicketTag(mi) {
    const result = `<ticket>\n` +
        `<path></path>\n` +
        `</ticket>`;
    return result;
}
function generatePdfTag(mi) {
    const pdfFilename = mi.docMap.filename;
    const result = `<pdf>\n` +
        `<path>${pdfFilename}</path>\n` +
        `</pdf>`;
    return result;
}
function generateConfigTag(mi) {
    const resourceMappingMode = "NORMAL";
    const result = `<config>\n` +
        `<resource_mapping_mode>${resourceMappingMode}</resource_mapping_mode>\n` +
        `</config>`;
    return result;
}
export const ncodeToPoint72 = (p) => {
    const NCODE_SIZE_IN_INCH = 8 * 7 / 600;
    const POINT_72DPI_SIZE_IN_INCH = 1 / 72;
    const ratio = NCODE_SIZE_IN_INCH / POINT_72DPI_SIZE_IN_INCH;
    return p * ratio;
};
function generatePagesTag(mi) {
    const numPages = mi.docMap.numPages;
    let result = `<pages count="${numPages}">\n`;
    // 각 페이지별로, x1, y1, x2, y2, crop_margin 값을 세팅 (모두 pu)
    // 추가로 nl_lib_zoom 이라는 값을 넣는다. 이 값은 PDF를 축소해서 인쇄하는 경우가 있기 때문이다
    for (const [index, page] of mi.docMap.pages.entries()) {
        const pu = page.pdfDesc.size_pu;
        const nu = {
            Xmin: page.npageArea.reduce((pv, c) => Math.min(pv, c.x), page.npageArea[0].x),
            Ymin: page.npageArea.reduce((pv, c) => Math.min(pv, c.y), page.npageArea[0].y),
            Xmax: page.npageArea.reduce((pv, c) => Math.max(pv, c.x), page.npageArea[0].x),
            Ymax: page.npageArea.reduce((pv, c) => Math.max(pv, c.y), page.npageArea[0].y),
            width: 0,
            height: 0,
        };
        nu.width = nu.Xmax - nu.Xmin;
        nu.height = nu.Ymax - nu.Ymin;
        const crop_margin_l = ncodeToPoint72(nu.Xmin);
        const crop_margin_t = ncodeToPoint72(nu.Ymin);
        const crop_margin_r = 0;
        const crop_margin_b = 0;
        const x1 = 0;
        const y1 = 0;
        const x2 = crop_margin_l + pu.width;
        const y2 = crop_margin_t + pu.height;
        // homography도 넣어줘야 한다.
        const { a, b, c, d, e, f, g, h } = page.h;
        // printed scale은 1:1 (즉, pu/nu)일 때 1,
        // 축소되어 인쇄되면 1보다 작은 값
        // 확대되어 인쇄되면 1보다 큰 값
        const printed_scale = ncodeToPoint72(1) / (pu.width / nu.width);
        const pgStr = `<page_item number="${index}" ` +
            // kitty upgraded, 2021/06/14
            `printed_scale="${printed_scale}" ` +
            // kitty upgraded, 2021/06/14
            `homography="${a},${b},${c},${d},${e},${f},${g},${h},1" ` +
            `rotate_angle="0" ` +
            `x1="${x1}" y1="${y1}" x2="${x2}" y2="${y2}" ` +
            `crop_margin="${crop_margin_l},${crop_margin_t},${crop_margin_r},${crop_margin_b}" ` +
            `bg_disabled="false" ` +
            `page_type="0" ` +
            `/>\n`;
        result = result + pgStr;
    }
    result = result + `</pages>`;
    return result;
}
function generateActionTableTag(mi) {
    const result = `<action_table>\n` +
        // `<action>ChangeLanguage_Chinese</action>\n` +
        // `<action>ChangeLanguage_English</action>\n` +
        // `<action>ChangeLanguage_Japanese</action>\n` +
        // `<action>Toggle_Language</action>\n` +
        // `<action>Custom</action>\n` +
        // `<action>DebugEnd</action>\n` +
        // `<action>DebugStart</action>\n` +
        // `<action>Play</action>\n` +
        // `<action>RecordEnd</action>\n` +
        // `<action>RecordPlay</action>\n` +
        // `<action>RecordStart</action>\n` +
        // `<action>StartRecord &gt;&gt;TmpFile</action>\n` +
        // `<action>PlayEx</action>\n` +
        // `<action>Stop</action>\n` +
        // `<action>VolumeDown</action>\n` +
        // `<action>VolumeUp</action>\n` +
        // `<action>ContinuePlay</action>\n` +
        // `<action>Icon</action>\n` +
        // `<action>Action1</action>\n` +
        // `<action>Action2</action>\n` +
        // `<action>Action3</action>\n` +
        // `<action>Action4</action>\n` +
        // `<action>Action5</action>\n` +
        // `<action>Action6</action>\n` +
        // `<action>Action7</action>\n` +
        // `<action>Action8</action>\n` +
        // `<action>Action9</action>\n` +
        // `<action>Action10</action>\n` +
        // `<action>Answer1</action>\n` +
        // `<action>Answer2</action>\n` +
        // `<action>Question</action>\n` +
        // `<action>Q&amp;A</action>\n` +
        // `<action>UserAnswer</action>\n` +
        // `<action>CustomDraw</action>\n` +
        // `<action>NcodeBarcode</action>\n` +
        // `<action>NcodeLabel</action>\n` +
        `</action_table>`;
    return result;
}
function generateSymbolsTag(mi) {
    const result = `<symbols>\n` +
        // `<symbol page="0" page_name="001" type="Rectangle" x="700.76" y="90.8104" width="69.3745" height="67.8155" lock="1" xylock="0">\n` +
        // `<name>3_1</name>\n` +
        // `<id>{4be81a8a-ae72-4774-8f4f-de63248c91ed}</id>\n` +
        // `<command name="3_1" action="youtube" param="d423KduCCJg"/>\n` +
        // `<language_resources>\n` +
        // `<language resource_country="korean" resource_type="" resource_id=""/>\n` +
        // `<language resource_country="english" resource_type="" resource_id=""/>\n` +
        // `<language resource_country="chinese" resource_type="" resource_id=""/>\n` +
        // `<language resource_country="japanese" resource_type="" resource_id=""/>\n` +
        // `</language_resources>\n` +
        // `<matching_symbols previous="" next=""/>\n` +
        // `</symbol>\n` +
        // `<symbol page="68" page_name="069" type="Rectangle" x="504.236" y="704.393" width="50.9266" height="50.2337" lock="1" xylock="0">\n` +
        // `<name>3_1_67_25</name>\n` +
        // `<id>{a005b49b-23ef-4430-954b-e3f552e86e55}</id>\n` +
        // `<command name="3_1_67_25" action="remedial" param="https://cls10.edunet.net/play/view.do?e=G2yDDzdwR&amp;n=0"/>\n` +
        // `<language_resources>\n` +
        // `<language resource_country="korean" resource_type="" resource_id=""/>\n` +
        // `<language resource_country="english" resource_type="" resource_id=""/>\n` +
        // `<language resource_country="chinese" resource_type="" resource_id=""/>\n` +
        // `<language resource_country="japanese" resource_type="" resource_id=""/>\n` +
        // `</language_resources>\n` +
        // `<matching_symbols previous="" next=""/>\n` +
        // `</symbol>\n` +
        `</symbols>`;
    return result;
}
/**
 *
 *
 * @export
 * @param {PdfDocMapper} mi - mapper item
 * @return {*}
 */
export default function generateNprojFromDocMapper(mi) {
    const preset = generatePresetTag(mi);
    const book = generateBookTag(mi);
    const ticket = generateTicketTag(mi);
    const pdf = generatePdfTag(mi);
    const config = generateConfigTag(mi);
    const pages = generatePagesTag(mi);
    const actions = generateActionTableTag(mi);
    const symbols = generateSymbolsTag(mi);
    const result = `<?xml version="1.0" encoding="UTF-8"?>\n` +
        `<!DOCTYPE nproj>\n` +
        `<nproj version="2.31" category="simple">\n` +
        `${preset}\n` +
        `${book}\n` +
        `${ticket}\n` +
        `${pdf}\n` +
        `${config}\n` +
        `${pages}\n` +
        `${actions}\n` +
        `${symbols}\n` +
        `<resources>\n` +
        `</resources>\n` +
        `</nproj>\n`;
    return result;
}
//# sourceMappingURL=generateNprojFromDocMapper.js.map